import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import FinanceAssetCodeApprvService from "services/Setup/Master/financeAssetCodeApprvService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  financeAssetCodeApprvList: {},
};

export const getFinanceAssetCodeApprvList = createAsyncThunk(
  "financeAssetCodeApprv/getFinanceAssetCodeApprvList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await FinanceAssetCodeApprvService.getFinanceAssetCodeApprvList(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const financeAssetCodeApprv = createSlice({
  name: "financeAssetCodeApprv",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get financeAsset code list
      .addCase(getFinanceAssetCodeApprvList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getFinanceAssetCodeApprvList.fulfilled, (state, action) => {
        state.loading = false;
        state.financeAssetCodeApprvList = action.payload;
      })
      .addCase(getFinanceAssetCodeApprvList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  financeAssetCodeApprv.actions;

export default financeAssetCodeApprv.reducer;
